var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconUrl01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 9"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.843.223H7.25v5.08c-.005 1.671-1.262 2.815-3.158 2.815-1.907 0-3.153-1.144-3.158-2.814V.223H2.33v4.963c.005.982.688 1.68 1.762 1.686 1.074-.005 1.75-.704 1.75-1.686zM8.69 8V.223h2.921c1.784 0 2.734.999 2.74 2.481-.006 1.058-.49 1.842-1.402 2.213L14.629 8h-1.557l-1.525-2.847h-1.461V8zm1.396-4.018h1.31c1.053.006 1.526-.445 1.526-1.278 0-.827-.473-1.31-1.526-1.31h-1.31zM15.554 8V.223h1.396v6.595h3.438V8z"
})));
export default SvgIconUrl01;